/**
 * 무빈소 퍼널 B안 랜딩 세션 마킹.
 *
 * 네이버 SA 특정 소재(nad-a001-01-000000603202465)로 유입된 사용자에게
 * 첫 화면을 B안(후기 캐러셀 + 장례지도사 영상)으로 노출한다.
 *
 * n_ad 쿼리는 새로고침이나 카카오 리다이렉트 시 유실될 수 있어,
 * 진입 시점에 sessionStorage 로 마킹해 탭 내에서 유지한다.
 * `matchRequestNeedsContext.ts`, `regionLoginContext` 와 같은 패턴.
 */

const MUBINSO_LANDING_B_KEY = "mubinso_landing_b";
const TARGET_NAD = "nad-a001-01-000000603202465";

/**
 * 진입 시 n_ad 를 확인해 타겟 소재면 세션에 마킹.
 *
 * @param nAd - router.query.n_ad (string | string[] | undefined)
 */
export const markMubinsoLandingB = (nAd: string | string[] | undefined) => {
  if (typeof nAd !== "string") return;
  if (nAd !== TARGET_NAD) return;
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(MUBINSO_LANDING_B_KEY, "1");
  } catch {
    // 사파리 프라이빗 등 쓰기 실패. 마킹이 없으면 A안으로 흐른다
  }
};

/**
 * B안 대상인지 판별 (현재 쿼리 OR 세션 마킹).
 *
 * @param nAd - router.query.n_ad (string | string[] | undefined)
 * @returns B안 노출 대상이면 true
 */
export const isMubinsoLandingBTarget = (nAd: string | string[] | undefined): boolean => {
  if (typeof nAd === "string" && nAd === TARGET_NAD) return true;
  if (typeof window === "undefined") return false;
  try {
    return sessionStorage.getItem(MUBINSO_LANDING_B_KEY) !== null;
  } catch {
    return false;
  }
};
